<div class="import-file-container">
    <div class="import-file-header">
        <div class="import-file-header">
            <ng-container *ngFor="let btn of btnFunctions">
                <button *ngIf="!btn.styleClass?.includes('btn-general'); else customBtn" [icon]="btn.icon ?? ''"
                    [label]="(btn.labelKey | transloco) ?? ''" [class]="btn.styleClass" pButton (click)="emitAction(btn.action)">
                </button>
                <ng-template #customBtn>
                    <button [class]="btn.styleClass" (click)="emitAction(btn.action)">
                        <i *ngIf="btn.icon" [class]="btn.icon"></i> {{ btn.labelKey | transloco }}
                    </button>
                </ng-template>
            </ng-container>
            <input #fileInput type="file" style="display: none" (change)="onFileSelected($event)" />
        </div>
    </div>

    <div class="file-info" [class.file-drop-hover]="isDragOver" (click)="onClickFileArea()"
        (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
        <ng-container *ngIf="selectedFile">
            <i class="pi pi-file"></i>
            <span>
                {{ selectedFile.name || ('importFile.noFile' | transloco) }} -
                {{ selectedFile.size ? ((selectedFile.size) / 1024 | number: '1.0-0') : '0' }} KB
            </span>
        </ng-container>
        <ng-container *ngIf="!selectedFile">
            <span>{{ 'importFile.dragDrop' | transloco }}</span>
        </ng-container>
    </div>
    <input #fileInput type="file" style="display: none" (change)="onFileSelected($event)" />

    <div *ngIf="currentStatus === STATUS_UPLOAD.UPLOADING">
        <p-progress-spinner ariaLabel="loading" />
    </div>

    <div class="process-status pending" *ngIf="currentStatus === STATUS_UPLOAD.PENDING">
        <ul>
            <li>{{ 'importFile.supportedFormats' | transloco }}</li>
            <li>{{ 'importFile.maxSize' | transloco }}</li>
            <li>{{ 'importFile.maxRows' | transloco }}</li>
        </ul>
    </div>

    <div class="process-status success" *ngIf="currentStatus === STATUS_UPLOAD.SUCCESS">
        <div class="status-header">
            <i class="pi pi-check-circle"></i>
            <span> {{ 'importFile.processCompleted' | transloco }}</span>
        </div>
        <ul>
            <li *ngFor="let field of responseFields">
                {{ field.label }}: {{ getResponseValue(field.key) }}
            </li>
        </ul>
    </div>

    <div class="process-status error" *ngIf="currentStatus === STATUS_UPLOAD.ERROR && !errorResponse">
        <div class="status-header">
            <i class="pi pi-exclamation-triangle"></i>
            <span> {{ 'importFile.errorsFound' | transloco: { count: errorsLocal.length } }}</span>
        </div>
        <ul>
            <li *ngFor="let error of errorsLocal">{{ error }}</li>
        </ul>
    </div>

    <div class="process-status error" *ngIf="currentStatus === STATUS_UPLOAD.ERROR && errorResponse">
        <div class="status-header">
            <i class="pi pi-exclamation-triangle"></i>
            <span> {{ 'importFile.fileError' | transloco: { name: errorResponse.name } }}</span>
        </div>
        <ul>
            <li>{{ 'importFile.status' | transloco }}: {{ errorResponse.statusCode }}</li>
            <li>{{ 'importFile.name' | transloco }}: {{ errorResponse.message }}</li>
        </ul>
    </div>

    <div class="button-container" *ngIf="currentStatus === STATUS_UPLOAD.SUCCESS">
        <button type="button" class="btn-general-black" (click)="openDetailsDialog()" [disabled]="!currentResponse">{{ 'importFile.viewDetails' | transloco }}</button>
        <button type="button" class="btn-general-black" (click)="downloadJson()" [disabled]="!currentResponse">{{ 'importFile.downloadReport' | transloco }}</button>
        <button type="button" class="btn-general-black" (click)="newBatch()">{{ 'importFile.newBatch' | transloco }}</button>
    </div>
</div>

<p-dialog [header]="'importFile.responseDetails' | transloco" [(visible)]="showDetailsDialog" [modal]="true" [style]="{width: '500px'}">
    <pre>{{ currentResponse | json }}</pre>
</p-dialog>